import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatSort, MatTableDataSource } from '@angular/material';
import { BaseComponent } from 'src/app/_base/base.component';
import { TeacherAllocations, SubjectsAllocation, TeacherInformations, AssignTeachers } from 'src/app/_models';
import { UserService, StudyTableService } from 'src/app/_services';
import * as _ from 'lodash';
@Component({
  selector: 'app-assign-teachers-manage',
  templateUrl: './assign-teachers-manage.component.html',
  styleUrls: ['./assign-teachers-manage.component.scss']
})
export class AssignTeachersManageComponent extends BaseComponent implements OnInit {
  @Input()
  assignTeachers: AssignTeachers = null;
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: false,
    suppressScrollY: true
  };
  @Output()
  update = new EventEmitter<null>();
  @ViewChild(MatSort) sort: MatSort;
  dataToBindSource = new MatTableDataSource<TeacherAllocations>();
  displayedColumns: string[] = ['i', 'teacherName', 'totalAndCurrentHours', 'teacherAllocationHour', 'actions'];
  headerName: string = 'AssignTeachers';
  teacher: SubjectsAllocation = null;
  teachers: SubjectsAllocation[] = [];
  teacherInformations: TeacherInformations = null;
  subjectWeeklyClasses: number = null;
  totalSubjectHours: number = 0;
  isSubmitted: boolean = false;
  constructor(private modalRef: BsModalRef, private userService: UserService, private studyTableService: StudyTableService) {
    super();
  }

  ngOnInit() {
    if (this.assignTeachers.teacherAllocations && this.assignTeachers.teacherAllocations.length > 0) {
      this.headerName = 'ManageTeachers';
      this.assignTeachers.teacherAllocations.map(item => {
        this.totalSubjectHours += item.teacherAllocationHour;
        item.sectionSubjectId = this.assignTeachers.sectionSubjectId;
      });
      this.dataToBindSource.data = _.cloneDeep(this.assignTeachers.teacherAllocations);
      setTimeout(() => {
        this.dataToBindSource.sort = this.sort;
      }, 50);
    }
    this.subjectWeeklyClasses = this.assignTeachers.subject.creditHours;
    this.getTeachersInit();
  }
  getTeachersInit(): void {
    if (BaseComponent.spinner) BaseComponent.spinner.isActive = true;
    this.userService.GetAllTeacherBySubject(this.assignTeachers.subject.subjectId).subscribe(
      (data: SubjectsAllocation[]) => {
        this.teachers = data;
        BaseComponent.spinner.isActive = false;
      },
      () => (BaseComponent.spinner.isActive = false)
    );
  }
  teacherChanged(): void {
    if (this.teacher) {
      BaseComponent.spinner.isActive = true;
      this.studyTableService.GetTeacherAllocationInfo(this.teacher.teacherId).subscribe(
        (data: TeacherInformations) => {
          this.teacherInformations = data;
          BaseComponent.spinner.isActive = false;
        },
        () => (BaseComponent.spinner.isActive = false)
      );
    } else this.teacherInformations = null;
  }
  weeklyChanged(): void {
    if (
      this.subjectWeeklyClasses > this.assignTeachers.subject.creditHours - this.totalSubjectHours ||
      (this.subjectWeeklyClasses < 1 && this.subjectWeeklyClasses !== null)
    )
      this.subjectWeeklyClasses = null;
  }
  assign(): void {
    this.isSubmitted = true;
    if (this.teacher && this.subjectWeeklyClasses !== null) {
      this.isSubmitted = false;
      if (!this.assignTeachers.teacherAllocations) this.assignTeachers.teacherAllocations = [];
      this.assignTeachers.teacherAllocations.push({
        teacherId: this.teacher.teacherId,
        teacherName: this.teacher.teacherName,
        teacherNameEn: this.teacher.teacherNameEn,
        teacherAllocationHour: this.subjectWeeklyClasses,
        totalAllocationHour: this.subjectWeeklyClasses + this.teacherInformations.totalWeeklyHour,
        settingAllocationHour: this.teacherInformations.settingWeeklyHour,
        sectionSubjectId: this.assignTeachers.sectionSubjectId
      });
      this.dataToBindSource.data = _.cloneDeep(this.assignTeachers.teacherAllocations);
      this.totalSubjectHours += this.subjectWeeklyClasses;
      this.teacher = null;
      this.teacherInformations = null;
      this.subjectWeeklyClasses = null;
      setTimeout(() => {
        this.dataToBindSource.sort = this.sort;
      }, 50);
    } else this.showError('PleaseFixAllErrorsFirst');
  }
  getDisabled(teacherId: string): boolean {
    return this.dataToBindSource.data.findIndex(item => item.teacherId === teacherId) !== -1;
  }
  delete(teacherAllocation: TeacherAllocations): void {
    const teacherIndex = this.assignTeachers.teacherAllocations.findIndex(
      item => item.teacherAllocationId === teacherAllocation.teacherAllocationId
    );
    if (teacherAllocation.teacherAllocationId) {
      const that = this;
      const callBack = function() {
        BaseComponent.spinner.isActive = true;
        that.studyTableService.DeleteTeacherAllocation(teacherAllocation.teacherAllocationId).subscribe(
          () => {
            that.assignTeachers.teacherAllocations.splice(teacherIndex, 1);
            that.dataToBindSource.data.splice(teacherIndex, 1);
            that.totalSubjectHours -= teacherAllocation.teacherAllocationHour;
            setTimeout(() => {
              that.dataToBindSource.sort = that.sort;
            }, 50);
            that.showSuccess('AcademicModule.TeacherAssignDeletedSuccessfully');
            BaseComponent.spinner.isActive = false;
          },
          () => {
            BaseComponent.spinner.isActive = false;
            that.showError('AcademicModule.ErrorWhileDeletingTeacherAssign');
          }
        );
      };
      this.showConfirmYesNoMessage(
        'AcademicModule.AreYouSureYouWantToDeleteTheAssignedTeacher?',
        'AcademicModule.DeleteAssignedTeacher',
        callBack
      );
    } else {
      this.assignTeachers.teacherAllocations.splice(teacherIndex, 1);
      this.dataToBindSource.data.splice(teacherIndex, 1);
      this.totalSubjectHours -= teacherAllocation.teacherAllocationHour;
      setTimeout(() => {
        this.dataToBindSource.sort = this.sort;
      }, 50);
    }
  }
  save(): void {
    if (this.assignTeachers.teacherAllocations && this.assignTeachers.teacherAllocations.length > 0) {
      BaseComponent.spinner.isActive = true;
      this.studyTableService.CreateOrUpdateTeacherAllocation(this.assignTeachers.teacherAllocations).subscribe(
        () => {
          if (this.headerName === 'ManageTeachers') this.showSuccess('AcademicModule.TeachersAssignUpdatedSuccessfully');
          else this.showSuccess('AcademicModule.TeachersAssignCreatedSuccessfully');
          BaseComponent.spinner.isActive = false;
          this.update.emit();
          this.modalClose();
        },
        () => {
          if (this.headerName === 'ManageTeachers') this.showError('AcademicModule.ErrorWhileUpdatingTeachersAssign');
          else this.showError('AcademicModule.ErrorWhileCreatingTeachersAssign');
          BaseComponent.spinner.isActive = false;
        }
      );
    } else this.showError('AcademicModule.PleaseAssignAtLeastOneTeacher');
  }
  modalClose(): void {
    this.isSubmitted = false;
    this.modalRef.hide();
  }
}
